export default __webpack_public_path__ + "static/870-e820b122924afd74dd630a8667543e2e.gif";